import React from "react";
import "./StatusBadge.css";

interface StatusBadgeProps {
  status: string;
}

// Define styles for different statuses
const statusStyles: { [key: string]: { color: string } } = {
  ACTIVE: { color: "#29997c" },
  INACTIVE: { color: "#ff914d" },
  PENDING: { color: "#38B6FF" },
  DEFAULT: { color: "#ff3131" },
};

// Function to capitalize the first letter of the status string
const capitalizeFirstLetter = (string: string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1)?.toLowerCase();
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  // Standardize the status to uppercase to handle different cases
  const standardizedStatus = status?.toUpperCase();
  // Get the appropriate style for the given status
  const style = statusStyles[standardizedStatus] || statusStyles.DEFAULT;
  // Capitalize the first letter of the status for display
  const displayStatus = capitalizeFirstLetter(status);

  return (
    <span className="capitalize-important" style={style}>
      {displayStatus}
    </span>
  );
};

export default StatusBadge;
